import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

import "swiper/css";
import "swiper/css/pagination";
import "./testimonial.css";

import one from "../../assets/testingimages/testimonials/t1.jpeg";
import two from "../../assets/testingimages/testimonials/t2.jpeg";
import three from "../../assets/testingimages/testimonials/t3.jpeg";
import four from "../../assets/testingimages/testimonials/t4.jpeg";
import five from "../../assets/testingimages/testimonials/t5.jpeg";
import six from "../../assets/testingimages/testimonials/t6.jpeg";
import seven from "../../assets/testingimages/testimonials/t7.jpeg";
import eight from "../../assets/testingimages/testimonials/t8.jpeg";

const testimonials = [
  { id: 1, avatar: one, name: "Muthu Kumar", title: "Fazo Academy", rating: 5, review: "I had a great learning experience at Fazo Academy. The small batch size allowed me to get individual attention from the mentors, and the one-on-one sessions really helped me improve my skills. The placement support was excellent — I got placed within two months of completing my course." },
  { id: 2, avatar: two, name: "Karthick", title: "Fazo Academy", rating: 4.6, review: "Fazo Academy offers hands-on training with live project exposure, making it easy to understand real-time IT work. The fee is affordable, and the quality of training is top-notch. The mentors are supportive and experienced — a great personalized learning experience." },
  { id: 3, avatar: three, name: "Sathya Priya", title: "Fazo Academy", rating: 5, review: "What I loved about Fazo Academy was their focus on practical knowledge and job readiness. The live project exposure gave me confidence in interviews. The mentors were always available, and the small batch ensured personal attention. I landed my first job soon after completing the course!", },
  { id: 4, avatar: four, name: "Hari", title: "Fazo Academy", rating: 4.9, review: "The one-on-one sessions at Fazo Academy were incredibly helpful. The batch size was small, so the learning experience was very personalized. Thanks to their guidance, I am now working in a good IT company!", },
  { id: 5, avatar: five, name: "Vaishaly", title: "Fazo Academy", rating: 5, review: "With only 3–4 students per batch, the trainers could focus on every student individually. The one-on-one sessions were very helpful. Affordable fees and genuine placement support — highly recommend Fazo Academy!", },
  { id: 6, avatar: six, name: "Pankaj", title: "Fazo Academy", rating: 4.7, review: "The personalized attention from mentors, small batch size, and affordable fees make Fazo Academy stand out. I learned a lot through their live projects, which helped me in interviews. Got my first job as a software developer thanks to them.", },
  { id: 7, avatar: seven, name: "Mohana", title: "Fazo Academy", rating: 3.9, review: "Fazo Academy provides high-quality training at an affordable price. The mentors are experienced, and their live project training gave me confidence to handle real-world challenges. A great place to start your career!", },
  { id: 8, avatar: eight, name: "Priya", title: "Fazo Academy", rating: 4.8, review: "As a fresher, I was looking for an institute that could provide practical knowledge and placement support. Fazo Academy delivered exactly that. Small batch size and one-on-one sessions made learning easy and effective.",},
];

export default function Testimonial() {
  const renderStars = (rating) => {
    const stars = [];
    const full = Math.floor(rating);
    const half = rating % 1 !== 0;

    for (let i = 0; i < full; i++) stars.push(<FaStar key={i} className="star full" />);
    if (half) stars.push(<FaStarHalfAlt key="half" className="star half" />);
    while (stars.length < 5) stars.push(<FaRegStar key={`empty-${stars.length}`} className="star empty" />);

    return <div className="stars">{stars}</div>;
  };

  return (
    <section className="testimonial-section">
      <section className="section-margin">
        <div className="headlines-for-all">
          <h4>
            <span>Feedback From </span> Happy Students
          </h4>
        </div>
      </section>

      <div className="testimonial-slider-container">
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={20}
          pagination={{ clickable: true }}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          speed={800}
          breakpoints={{
            0: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {testimonials.map((t) => (
            <SwiperSlide key={t.id}>
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <img src={t.avatar} alt={t.name} />
                  <div>
                    <h4>{t.name}</h4>
                    <span>{t.title}</span>
                    {renderStars(t.rating)}
                  </div>
                </div>
                <p className="testimonial-review">{t.review}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
